<script>
import { Cell, Popup, Grid, GridItem, Image } from 'vant'
import ObjectFunc from '@/tbs/util/ObjectFunc'
import Game from '@/tbs/model/vo/Game'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'game-team-suit-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-popup': Popup,
        'van-grid': Grid,
        'van-grid-item': GridItem,
        'van-image': Image,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label:String,
        value: String,
        placeholder: String,
        disabled: Boolean,
        clearable: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
    emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            selectedOptionUrl: null,
            suitList: []
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the area value to display on the cell item.
         */
        optionUrl() {
            let selectedUrl = ''
            if (this.selectedOptionUrl) {
                selectedUrl = this.selectedOptionUrl
            }
            else if (this.value) {
                if (this.value == '0') {
                    // 0 means none selection
                    return selectedUrl
                }
                for (let i = 0; i < this.suitList.length; i++) {
                    let item = this.suitList[i]
                    if (item.value === this.value) {
                        selectedUrl = item.url
                        break
                    }
                }
            }
            return selectedUrl
        },
        title() {
            return (new Game).localeProp('select-team-suit')
        },
        placeholderLabel() {
            if (!this.disabled) {
                return this.placeholder
            }
            return ''
        },
    },

    watch: {
        value(value) {
            if (value == null) {
                this.selectedOptionUrl = null
            }
        }
    },

    mounted() {
        // console.log('mounted updated value setter', this.value, this.options)
        if (this.value == null) {
            this.selectedOptionUrl = null
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {    
        onOptionLinkClick() {
            if (!this.disabled) {
                this.showPopup = true
            }
        },
        onOptionItemClick(item) {
            item = ObjectFunc.cloneObject(item)
            if (item.value === '0') {
                // 0 means cancel the selection
                item.url = ''
                item.value = ''
            }
            this.selectedOptionUrl = item.url
            this.showPopup = false
            this.$emit('change-data', item)
        },
        onClearBtnClick() {
            this.selectedOptionUrl = ''
            this.$emit('change-data', {
                url: '',
                value: ''
            })
        },
    },

    created() {
        this.suitList = (new Game).suitList
    },
}
</script>

<template>
    <!-- component -->
    <div class="game-team-suit-selector van-cell no-padding">
        <van-cell 
            :title="label"
            :class="{ disabled: disabled, placeholder: true }"
            :value="placeholderLabel"
            center
            @click="onOptionLinkClick"
        >
            <template v-if="optionUrl" #default>
                <div class="vertical-center justify-right">
                    <van-image 
                        :src="optionUrl" 
                        width="24px" 
                        height="24px"
                    />
                </div>
            </template>
            <template #right-icon>
                <div v-if="!disabled" class="l-inner-margin minor-color">
                    <div v-if="clearable">
                        <van-icon 
                            v-if="optionUrl" 
                            name="clear"
                            size="16"
                            @click.stop="onClearBtnClick"
                        />
                        <van-icon v-else name="arrow"/>
                    </div>
                    <div v-else>
                        <van-icon name="arrow"/>
                    </div>
                </div>
            </template>
        </van-cell>
        <van-popup v-model="showPopup" position="bottom" class="popup-container">
            <div>
                <div class="title-section text-center">
                    <span class="main-title">{{ title }}</span>
                    <span class="close-btn" @click="showPopup = false">
                        <i class="iconfont iconfont-close-black"/>
                    </span>
                </div>
                <van-grid :column-num="6" :border="false" class="u-outer-padding">
                    <van-grid-item 
                        v-for="item in suitList" 
                        :key="item.value"
                        @click="onOptionItemClick(item)">
                        <van-image 
                            :src="item.url" 
                            width="24px" 
                            height="24px"
                        />
                    </van-grid-item>
                </van-grid>
            </div>
        </van-popup>
    </div>
</template>